import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import TicketTypesList from './TicketTypesList'

export default function TicketTypes() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/ticket_types" component={TicketTypesList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}